import React from 'react';
import { Modal } from 'react-bootstrap';
import TypeReference from './type-reference';
import TypeSelector from './type-selector';
import '../../../css/values.less';
import '../../../css/types.less';

class TypeReferenceSelector extends React.Component {
    
    constructor(props) {
        super(props);

        this.componentRootRef = React.createRef();

        this.state = { isTypeSelectorOpen: false };

        this.openTypeSelector = this.openTypeSelector.bind(this);
        this.closeTypeSelector = this.closeTypeSelector.bind(this);
        this.removeType = this.removeType.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    openTypeSelector() {
        this.setState({ isTypeSelectorOpen: true });
    }

    closeTypeSelector() {
        this.setState({ isTypeSelectorOpen: false });
    }

    removeType(e) {
        e.preventDefault();
        e.stopPropagation();
        this.onChange(null);
    }

    onChange(type) {
        this.closeTypeSelector();

        if (type)
            manywho.state.setComponent(this.props.id, { objectData: [type] }, this.props.flowKey);
        else
            manywho.state.setComponent(this.props.id, { objectData: [] }, this.props.flowKey);

        manywho.component.handleEvent(this, manywho.model.getComponent(this.props.id, this.props.flowKey), this.props.flowKey);
        this.forceUpdate();
    }

    render() {

        let element = this.componentRootRef.current;

        // get the closest flow root element up the DOM tree
        // ELEMENT.closest is not supported in IE
        while (
            element
            && (element = element.parentElement)
            && !element.classList.contains('flow')
        ) {
            this.modalContainer = element;
        }

        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);

        manywho.log.info('Rendering Type Reference: ' + this.props.id);

        const state = manywho.state.getComponent(this.props.id, this.props.flowKey) || {};

        if (model.isVisible === false)
            return null;

        let selectedType = null;
        if (state && state.objectData && state.objectData.length > 0)
            selectedType = state.objectData[0];
        else
            selectedType = (model.objectData || []).filter(objectData => objectData.isSelected)[0];

        let flowId = null;
        if (model.tags)
            flowId = manywho.utils.getObjectDataProperty(model.tags, 'FlowId');

        const isLoading = state.loading !== null && typeof state.loading !== 'undefined';

        let typeReference = null;
        if (selectedType && !manywho.utils.isPlaceholderObjectData([selectedType]))
            typeReference = <div className="value-reference-value form-group value-selected" onClick={this.openTypeSelector}>
                <TypeReference reference={selectedType} />
                <button className="btn btn-default btn-link" onClick={this.openTypeSelector}>Select</button>
                <button className="btn btn-default btn-link" onClick={this.removeType}>Remove</button>
            </div>;
        else
            typeReference = <button className="btn btn-primary btn-select-type" onClick={this.openTypeSelector}>Select a Type</button>

        let label = null;
        if (!manywho.utils.isNullOrWhitespace(model.label) || model.isRequired)
            label = <label>
                {model.label}
                {(model.isRequired) ? <span className="input-required"> *</span> : null}
            </label>;

        let className = 'value-reference-selector';
        if (model.isValid === false)
            className += ' has-error';

        if (model.isEnabled === false || isLoading)
            className += ' disabled';

        return <div className={className} id={this.props.id} ref={this.componentRootRef}>
            {label}
            {typeReference}
            {model.isValid === false ? <span className="help-block">{model.validationMessage}</span> : null}
            <Modal className="value-selector-dialog-container" container={this.modalContainer} show={this.state.isTypeSelectorOpen} onHide={this.closeTypeSelector} backdrop={true} bsSize="large" dialogClassName="value-selector-dialog">
                <Modal.Body>
                    <TypeSelector reference={selectedType} objectDataRequest={model.objectDataRequest} onChange={this.onChange} flowId={this.props.flowId} authenticationToken={this.props.authenticationToken} isVisible={this.state.isTypeSelectorOpen} onCancel={this.closeTypeSelector} />
                </Modal.Body>
            </Modal>
        </div>;
    }

}

export default TypeReferenceSelector;
